import { useTranslation } from "react-i18next";

import { Text } from "#components/atoms/Typographies/Text";

export const NestingPlanEmpty = () => {
  const { t } = useTranslation();

  return <Text size="small">{t("layout.sidePanel.noNestingRun")}</Text>;
};
